import { ControlsVisibility } from '../../../WorkflowEngine/workflowEngineReducer';
import getControlSchemaProperty from '../../../Shared/jsonSchemaUtilities/getControlSchemaProperty';
import getConditionalControls from '../getConditionalControls';
import PageState from '../../../Shared/pageState';

export default (pages: PageState[], controlIds: string[]) => {
  const controlsVisibility: ControlsVisibility = { show: [], hide: [] };
  const conditionalControls = getConditionalControls(pages);

  // determine visibility of conditional controls
  for (const control of conditionalControls) {
    const controlId = getControlSchemaProperty(control, 'id') as string;
    if (controlIds.includes(controlId)) {
      controlsVisibility.show.push(control.id);
    } else {
      controlsVisibility.hide.push(control.id);
    }
  }

  return controlsVisibility;
};
